import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import env from '../env';
import {
  KK_UTM_SOURCE,
  KK_UTM_COMPAIGN,
  KK_UTM_MEDIUM,
} from '../Common/Utils/extensionSDK';

const key = 'KINDRED_PARTNER_SAMSUNG';

interface PartnerSamsungProps {
  partnerId?: string | null;
  userId?: string | null;
  userCurrency?: string | null;
  userCountryCode?: string | null;
}

export const setPartnerSamsungProps = (props: PartnerSamsungProps) => {
  localStorage.setItem(key, JSON.stringify(props));
};

export const getPartnerSamsungProps = (): PartnerSamsungProps | null => {
  const result = localStorage.getItem(key);

  if (result) {
    return JSON.parse(result);
  }

  return null;
};

export const usePartnerSamsungQueryParamExtraction = () => {
  useEffect(() => {
    const partnerSamsungProps = getPartnerSamsungProps() ?? {};

    const url = new URL(location.href);

    if (url.searchParams.has('partnerId')) {
      partnerSamsungProps.partnerId = url.searchParams.get('partnerId');
    }

    if (url.searchParams.has('userId')) {
      partnerSamsungProps.userId = url.searchParams.get('userId');
    }

    if (url.searchParams.has('userCurrency')) {
      partnerSamsungProps.userCurrency = url.searchParams.get('userCurrency');
    }

    if (url.searchParams.has('userCountryCode')) {
      partnerSamsungProps.userCountryCode =
        url.searchParams.get('userCountryCode');
    }

    setPartnerSamsungProps(partnerSamsungProps);
  }, []);
};

export const usePartnerSamsungParams = () => {
  const history = useHistory();

  useEffect(() => {
    const params = getPartnerSamsungProps();

    const url = new URL(window.location.href);
    if (params?.partnerId) {
      url.searchParams.set('pid', params?.partnerId);
    }
    if (params?.userId) {
      url.searchParams.set('uid', params?.userId);
    }
    if (params?.userCurrency) {
      url.searchParams.set('uc', params?.userCurrency);
    }
    if (params?.userCountryCode) {
      url.searchParams.set('ucc', params?.userCountryCode);
    }

    history.push(`${url.pathname}${url.search}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useChromeExtensionUTMQueryParamExtraction = () => {
  useEffect(() => {
    const url = new URL(location.href);

    if (url.searchParams.has('utm_source')) {
      const utm_source = url.searchParams.get('utm_source');
      localStorage.setItem(KK_UTM_SOURCE, utm_source as string);
    }

    if (url.searchParams.has('utm_campaign')) {
      const utm_campaign = url.searchParams.get('utm_campaign');
      localStorage.setItem(KK_UTM_COMPAIGN, utm_campaign as string);
    }

    if (url.searchParams.has('utm_medium')) {
      const utm_medium = url.searchParams.get('utm_medium');
      localStorage.setItem(KK_UTM_MEDIUM, utm_medium as string);
    }
    location.href = env.chrome_extension_store_url;
  }, []);
};
